<template>
  <div class="p-4 rounded-xl shadow-md bg-white space-y-2">
    <div>
      <p class="text-sm font-medium text-gray-500">Objectif du jour</p>
      <div class="flex items-center my-4">
        <CheckCircleIcon v-if="isCompleted" class="h-6 w-6 flex-shrink-0 text-purple-600" />
        <DotsCircleHorizontalIcon v-else class="h-6 w-6 flex-shrink-0 text-gray-600" />
        <p class="ml-2 text-2xl text-black">Réaliser {{ $t("roadmap.sales", target) }} d'assurance</p>
      </div>
    </div>
    <span class="text-xs text-gray-600">{{ current }} / {{ target }} contrats vendus</span>
    <ProgressionBar :value="current" :max="target" />
  </div>
</template>

<script>
import { ProgressionBar } from "@estaly/ui";
import { CheckCircleIcon, DotsCircleHorizontalIcon } from "@heroicons/vue/outline";

export default {
  components: {
    ProgressionBar,
    CheckCircleIcon,
    DotsCircleHorizontalIcon,
  },
  props: {
    current: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isCompleted() {
      return this.current >= this.target;
    },
  },
};
</script>
